import request from '@/services/request'
import { getApiUrl } from '@/utils/tool'

export function getMain(object) {
  return request({
    baseURL: getApiUrl(),
    url: '/transaction/main',
    method: 'post',
    data: object
  })
}

export function getCommission(object) {
  return request({
    baseURL: getApiUrl(),
    url: '/transaction/commission',
    method: 'post',
    data: object
  })
}

export function getBonus(object) {
  return request({
    baseURL: getApiUrl(),
    url: '/transaction/bonus',
    method: 'post',
    data: object
  })
}
